<template>
  <div>
    <home-banner></home-banner>
    <introduce></introduce>
    <home-api-list></home-api-list>
    <customer></customer>
  </div>
</template>

<script>
import HomeBanner from '@/components/HomeBanner'
import Introduce from '@/components/Introduce'
import HomeApiList from '@/components/HomeApiList'
import Customer from '@/components/Customer'

export default {
  name: 'Home',
  components: {
    HomeBanner,
    Introduce,
    HomeApiList,
    Customer
  }
}
</script>

<style lang="scss" scoped>

</style>
